export type SupplementsConfig = {
  [key: string]: {
    description?: string
  }
}

const supplements_config: SupplementsConfig = {
  probiotics: {
    description:
      'Probiotics, prebiotics, and digestive enzymes to improve digestion (10 pack)',
  },
  no_addon: {},
}

export default supplements_config
